import { Collection } from 'backbone';
import BaseData, { ATTRIBUTES } from '../data/baseData';
import SpritePlayer from './spritePlayer';

/**
 * @typedef {import('./spritePlayer').SpriteAttributes} SpriteAttributes
 */

/** @enum {string} */
const SPRITE_IDS = Object.freeze({
	userLevel7: 'userLevel_7',
	userLevel10: 'userLevel_10',
	wellConnectedFireworks: 'wellConnectedFireworks',
	wordSearchFireworks: 'wordSearchFireworks',
	tilePopBoardCleared: 'tilePopBoardCleared',
	tileSwapImageSolved: 'tileSwapImageSolved',
	thumbsUp: 'thumbsUp',
	heartBreak: 'heartBreak',
});

const EVENTS = Object.freeze({
	INITIALIZED: 'initialized',
});

export { EVENTS, SPRITE_IDS };

class SpriteFactory extends BaseData {
	/**
	 * @returns {string} Identifier for the class name
	 */
	get CN() {
		return SpriteFactory.name;
	}

	defaults() {
		return {
			...super.defaults(),
			[ATTRIBUTES.type]: 'spriteFactory',
			[ATTRIBUTES.contentUrl]: '//devtv.hollywoodplayer.com/json/sprites.json',
		};
	}

	constructor(options) {
		super(options);
		this.logger.log(`[${this.constructor.name}]<${BaseData.name}>`, { ...options });

		/** @type {Collection<SpriteAttributes>} */
		this.sprites = this.sprites || new Collection();
	}

	/**
	 * Uses provided data to create a new SpritePlayer instance
	 * @param {SpriteAttributes} options Data object that must include id or spriteId
	 * and can include override data for the SpritePlayer
	 * @returns {SpritePlayer} The sprite player created from the given data
	 */
	createSprite(options) {
		this.logger.log(`[${this.createSprite.name}]`, { ...options });

		const { id, spriteId } = options;
		const spriteData = { ...this.sprites.get(id || spriteId)?.toJSON() };

		if (!spriteData) {
			this.logger.warn(`[Missing sprite data for id: ${id || spriteId}]`);
		}

		return new SpritePlayer({ ...spriteData, ...options });
	}
}

// Create instance to export as singleton
export default new SpriteFactory();
